import { isString } from 'lodash';
import { Button, ButtonVariant } from '@lendi-ui/button';
import Modal from '@lendi-ui/modal';
import { Body } from '@lendi-ui/typography';

import { useAnalytics } from '@funnels/providers';
import { run } from '@funnels/utils';

import { ButtonsWrapper, DialogContent } from './style';

interface ConfirmDialogProps {
  title?: string;
  body?: string | React.ReactNode;
  isVisible: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  centeredContent?: boolean;
  displayWarning?: boolean;
  confirmButtonText: string;
  confirmButtonVariant?: ButtonVariant;
  shouldHideCancelButton?: boolean;
}

export const ConfirmDialog = (props: ConfirmDialogProps) => {
  const { tracking } = useAnalytics();
  const {
    title,
    body,
    isVisible,
    onCancel,
    onConfirm,
    confirmButtonText,
    confirmButtonVariant = 'primary',
    centeredContent = false,
    displayWarning = false,
    shouldHideCancelButton = false,
  } = props;

  return (
    <Modal role="dialog" isVisible={isVisible} size="md" onHide={onCancel} isHeaderFixed>
      {title && <Modal.Header title={title} size="xs" />}
      <Modal.Content>
        <DialogContent centered={centeredContent}>
          {!!body && isString(body) ? <Body mt="xxs">{body}</Body> : body}
          {displayWarning && <Body mt="xxs">This cannot be undone.</Body>}
          {displayWarning && <Body mt="xxs">Do you want to continue?</Body>}
        </DialogContent>
      </Modal.Content>
      <Modal.Footer>
        <ButtonsWrapper>
          <Button
            variant={confirmButtonVariant}
            onClick={run(onConfirm, () => tracking?.button.emphasis({ text: confirmButtonText }))}
            isFullWidth
          >
            <Body>{confirmButtonText}</Body>
          </Button>
          {!shouldHideCancelButton && (
            <Button variant="secondary" onClick={onCancel} isFullWidth>
              <Body>CANCEL</Body>
            </Button>
          )}
        </ButtonsWrapper>
      </Modal.Footer>
    </Modal>
  );
};
